import { useLocalObservable } from 'mobx-react-lite';
import { createContext, PropsWithChildren, useContext } from 'react';

import { useRootStore } from '@/configs/store';

import { LoginPageStore } from './LoginPageStore';

type ContextValue = LoginPageStore;

const Context = createContext<ContextValue>({} as ContextValue);

export const LoginPageStoreProvider = ({ children }: PropsWithChildren) => {
  const { userStore, alertsStore } = useRootStore();

  const store = useLocalObservable(() => new LoginPageStore({ userStore, alertsStore }));

  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useLoginPageStore = () => useContext(Context);
